/** Archive-status chip styling, same shape as `learning-suite/admin/constants/release-status.ts`. */
export const ARCHIVE_STATUS = {
  active: {
    label: 'Aktiv',
    lamp: 'bg-[#16A34A] shadow-[0_0_0_3px_rgba(22,163,74,0.16)]',
    chip: 'bg-green-50 text-green-700 border border-green-200'
  },
  archived: {
    label: 'Archiviert',
    lamp: 'bg-[#888888] shadow-[0_0_0_3px_rgba(136,136,136,0.16)]',
    chip: 'bg-[#F2F4F7] text-[#667085] border border-[#E4E7EC]'
  }
} as const;

export const archiveStatusOf = (isArchived: boolean) => (isArchived ? ARCHIVE_STATUS.archived : ARCHIVE_STATUS.active);
